/**
 * To avoid merge conflicts, please add new params to a random location (not the last line).
 */
export enum queryParams {
  COMPONENT_SECTIONS_TAB = 'tab',
  COMPONENT_SECTIONS_SECTION = 'section',
  BUSINESS_CASE_CHECKOUT = 'checkoutSection',
  SOURCING_EXTERNAL_ID = 'sourcingExternalId',
  BUSINESS_CASE_CHECKOUT_ORDER = 'CheckoutOrder',
  BUSINESS_CASE_SALE_VEHICLE = 'businessCaseSaleVehiclesTabs',
  BUSINESS_CASE_PURCHASE_VEHICLE = 'businessCasePurchaseVehicles',
  BUSINESS_CASE_FINANCING_ENDING_OPERATION = 'operation',
  BUSINESS_CASE_FINANCING_ENDING_END_DATE = 'endDate',
  BUSINESS_CASE_FINANCING_ENDING_PERIOD = 'period',
  BUSINESS_CASE_CHECKOUT_CREATED_CORRECTIVE_DOCUMENT_TYPE = 'createdCorrectiveDocumentType',
  SERVICE_CASE_ADD_LABOUR_JOB_ID = 'addLabourJobId',
  SERVICE_CASE_ADD_MATERIAL_REQUEST_JOB_ID = 'addMaterialRequestJobId',
  SERVICE_CASE_CHECKIN_HANDOVER = 'checkinHandover',
  SERVICE_CASE_INSPECTION = 'inspection',
  RENTAL_ORDER_INSPECTION = 'rentalOrderInspection',
  SERVICE_CASE_JOB_ID = 'jobId',
  SERVICE_CASE_OPEN_JOB_ID = 'openJobId',
  SERVICE_CASE_ID = 'serviceCaseId',
  SERVICE_CASE_ORDER_ID = 'orderId',
  SERVICE_CASE_ORDER_TAB = 'orderTab',
  SERVICE_CASE_REPAIR_ID = 'repairId',
  RECORD_AUDIT_LINKED_RESOURCE_ID = 'auditResourceId',
  RECORD_AUDIT_LINKED_RECORD_ID = 'auditRecordId',
  SERVICE_ORDER_RETURN_ID = 'serviceOrderReturnId',
  SERVICE_ORDER_RETURN_AUTHORIZATION_PROFILE_ID = 'serviceOrderReturnAuthorizationProfileId',
  CATALOG_NUMBER = 'catalogNumber',
  COMMENT_ID = 'commentId',
  COMMUNICATION_SCROLL_TO_OLDEST_UNREAD = 'scrollToOldestUnread',
  VEHICLE_ADVERTISEMENT_PLATFORMS = 'platforms',
  VEHICLE_ADVERTISEMENT_PUBLISHING = 'publishing',
  VEHICLE_CREATE = 'createVehicle',
  VEHICLE_CLONE_COPY_PRICES = 'copyPrices',
  REDIRECT_SOURCE = 'source',
  REDIRECT_FLOW = 'flow',
  RETURN_URL = 'returnUrl',
  BRANCH_ID = 'branchId',
  VEHICLE_PURCHASE_TYPE = 'purchaseType',
  AFTERSALES_CHECKOUT_TAB = 'aftersalesCheckoutTab',
  CUSTOMER_ID = 'customerId',
  VEHICLE_ID = 'vehicleId',
  SERVICE_CASE_JOB_SEGMENT = 'serviceCaseJobSegment',
}
/**
 * To avoid merge conflicts, please add new params to a random location (not the last line).
 */
